import { topicManagement } from "./topicManagement";
import { colors } from "../../stripeColors";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
import TopicContentIcon from "../../../components/Common/SvgIcons/OrganizeIcons/TopicContentIcon";
import { organize } from "./organize";
import PublishGroupTopicIcon from "../../../components/Common/SvgIcons/OrganizeIcons/PublishGroupTopicIcon";
import { FormattedMessage } from "react-intl";

export let addGroupTopic = {
  name: "Add New Topic",
  editName: "Edit Topic",
  editpath: (tenantName) =>
    `/${tenantName}/organize/topicManagement/editGroupTopic`,
  path: (location, params, tenantName) =>
    location?.pathname.includes(addGroupTopic.editpath(tenantName))
      ? `${addGroupTopic.editpath(tenantName)}/${params?.groupTopicID}`
      : `/${tenantName}/organize/topicManagement/createGroupTopic`,
  navLinks: (navigate, tenantName, location, params) => [
    {
      key: 1,
      label: <FormattedMessage id="TOPICMANAGEMENT_TEXT" />,
      path: `/${tenantName}/organize`,
      onClick: () => navigate(`${organize.path(tenantName)}/topicManagement`),
    },
    {
      key: 2,
      label: `${addGroupTopic.name}`,
      label: location?.pathname?.includes(addGroupTopic.editpath(tenantName))
        ? addGroupTopic.editName
        : addGroupTopic.name,
      path: `${location?.pathname}`,
      // onClick: () =>
      //   navigate(`${addGroupTopic.path(location, params, tenantName)}`),
    },
  ],

  tiles: (navigate, location, params, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DETAILS_TEXT" />,
      path: `${addGroupTopic.path(location, params, tenantName)}/details`,
      color: colors.green,
      icon: (fill) => <DetailsIcon fill={fill} />,
      isCompleted: false,
      onClick: () =>
        navigate(`${addGroupTopic.path(location, params, tenantName)}/details`),
    },
    {
      key: 2,
      label: "Topic Content",
      path: `${addGroupTopic.path(location, params, tenantName)}/topicContent`,
      color: colors.purple,
      icon: (fill) => <TopicContentIcon fill={fill} />,
      isCompleted: false,
      onClick: () =>
        navigate(
          `${addGroupTopic.path(location, params, tenantName)}/topicContent`
        ),
    },
    {
      key: 3,
      label: "Publish Topic",
      path: `${addGroupTopic.path(
        location,
        params,
        tenantName
      )}/publishGroupTopic`,
      color: colors.orange,
      icon: (fill) => <PublishGroupTopicIcon fill={fill} />,
      // isCompleted: false,
      onClick: () =>
        navigate(
          `${addGroupTopic.path(location, params, tenantName)}/topicContent`
        ),
    },
  ],
};
